import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@spartacus/core';
import { IconModule, MediaModule } from '@spartacus/storefront';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KbCustomerIdDropdownModule } from '../kb-myAccount/kb-MyOwnPartNumbers/customer-id-drop-down/customer-id-drop-down.module';
import { OrderStatusListComponent } from './order-status-list/order-status-list.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { OrderStatusDetailsComponent } from './order-status-details/order-status-details.component';
import { KbMyAccountLeftSideNavModule } from '../kb-myAccount/my-account-left-sidenav/my-account-left-sidenav.module';
import { KbPaginationModule } from '../kb-pagination/kb-pagination/kb-pagination.module';
@NgModule({
  declarations: [OrderStatusListComponent, OrderStatusDetailsComponent],
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    IconModule,
    I18nModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MediaModule,
    KbCustomerIdDropdownModule,
    KbMyAccountLeftSideNavModule,
    ReactiveFormsModule,
    BsDatepickerModule,
    KbPaginationModule
  ],
})
export class KbOrderStatusModule {}
